import { render } from "./partfunction.vue?vue&type=template&id=772581fa&scoped=true"
import script from "./partfunction.vue?vue&type=script&lang=js"
export * from "./partfunction.vue?vue&type=script&lang=js"

import "./partfunction.vue?vue&type=style&index=0&id=772581fa&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772581fa"]])

export default __exports__